import { Button, FileUpload, FormField } from "@wix/design-system";
import React, { useContext } from "react";
import {
  EditorContext,
  PluginsEventsContext,
  RicosContext,
  UploadContext,
  useDevService
} from "./../../ricos-context";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common";
import { handleAudioUpload } from "./../handle-audio-upload";
import { audioFileTypes } from "../consts";
import { UPLOAD_TAB_UPLOAD_BUTTON } from "../data-hooks";
import { AUDIO_TYPE } from "../types";
const AudioUpload = ({
  nodeId,
  handleFileSelection,
  handleFileUpload,
  closeModal,
  logBi
}) => {
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const { uploadService } = useContext(UploadContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const devService = useDevService();
  const hasCustomFileUpload = Boolean(handleFileUpload || handleFileSelection);
  const publicCommands = getPublicCommands();
  const handleUploadClick = async () => {
    pluginsEvents.publishPluginPopoverClick?.({
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.upload
    });
    logBi({ dataHook: UPLOAD_TAB_UPLOAD_BUTTON });
    handleAudioUpload({
      services: { uploadService, devService },
      config: { handleFileSelection, handleFileUpload },
      publicCommands,
      nodeId,
      type: "audio"
    });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(FormField, { label: t("AudioModal_Upload_Title"), maxLines: 2 }, hasCustomFileUpload ? /* @__PURE__ */ React.createElement(FileUpload, { onChange: () => {
  }, accept: audioFileTypes }, () => /* @__PURE__ */ React.createElement(
    Button,
    {
      dataHook: UPLOAD_TAB_UPLOAD_BUTTON,
      onClick: handleUploadClick,
      fullWidth: true,
      size: "small"
    },
    t("AudioModal_Upload_ButtonText")
  )) : null);
};
export {
  AudioUpload
};
//# sourceMappingURL=audio-upload.js.map
